import title from './title.js';

export default dsf.component({
  name: 'DsfTitle2',
  mixins: [title],
  ctrlCaption: "二级标题",
  props: {
    value: {
      type: [String, Number],
      default: '标题2'
    },
    fontType: {
      type: Number,
      default: 2
    }
  }
});